<template>
    <v-container class="d-flex flex-column pa-0 ml-3">

          <v-btn :to="{name: 'ustawienia.placowki' }" x-large :color="$route.name === 'ustawienia.placowki' ? selectedColor : defaultColor"  width="250" active-class="aa" exact>
            Placówki  
              <v-chip
                class="ma-2"
                color="white"
                :text-color="$route.name === 'placowki' ? selectedColor : defaultColor"
                small
              >
                <strong>{{menuCount.settings.department}}</strong>
            </v-chip>
            </v-btn>

            <v-btn :to="{name: 'ustawienia.uzytkownicy' }" x-large :color="$route.name === 'ustawienia.uzytkownicy' ? selectedColor : defaultColor" dark width="250">
            Użytkownicy  
              <v-chip
                class="ma-2"
                color="white"
                :text-color="defaultColor"
                small
              
              >
                <strong>{{menuCount.settings.user}}</strong>
            </v-chip>
            </v-btn>

            <v-btn :to="{name: 'ustawienia.stanowiska' }" x-large :color="$route.name === 'ustawienia.stanowiska' ? selectedColor : defaultColor" dark width="250">
            Stanowiska  
              <v-chip
                class="ma-2"
                color="white"
                :text-color="defaultColor"
                small
              
              >
                <strong>{{menuCount.settings.group}}</strong>
            </v-chip>
            </v-btn>
    </v-container>
</template>

<script>
export default {
    data(){
        return{
            defaultColor:'secondary', 
            selectedColor:'primary'
        }
    },
    mounted(){
      //pobierabie liczników
      this.$store.dispatch( 'loadMenuSettingsCount' );
      //this.$store.dispatch( 'loadLookups' );
    },
    computed:{
      menuCount(){
        return this.$store.getters.getMenu;
      }
    },
}
</script>

<style scoped>
.v-btn{
  margin-bottom: 1em;
}
.v-chip{
  margin-left: 1em;
}
.v-chip:hover{
    cursor: pointer;
}

.v-btn:not(.v-btn--text):not(.v-btn--outlined).v-btn--active:before {
    opacity: 0;
}

</style>